module.exports = __webpack_public_path__ + "static/media/1 35 hvis.8e83acb8.mp3";